
@if (showWelcome && !state.hideWelcome) {
    <div class="lm-welcome-splash-wrapper">
        <svg class="icon-empty-state lm-facade-welcome-icon" focusable="false" aria-hidden="true" role="presentation">
            <use href="#icon-empty-no-analytics-new"></use>
        </svg>
        <div>
            <h2 class="lm-welcome-splash-header lm-bold lm-header-2">{{ 'Facade_WelcomeHeader' | translate }}<span class="lm-facade-welcome-new-box">{{ 'New' | translate}}</span></h2>
            <p class="lm-welcome-splash-text">{{ 'Facade_WelcomeText' | translate }}</p>
            <p class="lm-welcome-splash-dismiss-message"><svg soho-icon icon="info" class="icon info"></svg>{{ 'Facade_WelcomeDismiss' | translate }}</p>
        </div>
        <button soho-button="icon" [icon]="'close'" class="lm-welcome-splash-dismiss" (click)="dismissWelcomeMessage()"></button>
    </div>
}
@if(searchCategories().length > 0) {
    <div class="lm-facade-search">
            <form (ngSubmit)="doTextSearch()" class="lm-searchfield-form">
            <span soho-searchfield-wrapper>
                <input soho-searchfield
                       [placeholder]="searchPlaceholder()"
                       [clearable]="true"
                       [categories]="searchCategories()"
                       [showCategoryText]="true"
                       [categoryMultiselect]="true"
                       id="lm-reports-facade-category-search"
                       attr.data-automation-id="lm-reports-facade-category-search"
                       name="lm-reports-facade-category-search"
                       enterkeyhint="search"
                       [(ngModel)]="searchValue"
                       [ngModelOptions]="{standalone: true}"
                       (cleared)="clearTextSearch()"
                />
            </span>
            </form>
    </div>
}